import apiService from '@/api/apiService';

export const permissionList = async (pageSize, pageIndex) => {
    const url = '/api/admin/permissions';

    // 建立所有查詢參數的物件
    const queryParams = {
        page: pageIndex,
        page_size: pageSize
    };

    // 將物件轉換為 URL 參數
    const params = new URLSearchParams(queryParams);

    const response = await apiService.GET(`${url}?${params.toString()}`);

    // API 已統一為格式 A：{ status: 1, data: [...], page, page_size, total }
    // 直接回傳，前端統一使用 response.data 取得資料陣列
    return response;
};
